<template>
  <div class="mt-5">
    <label for="answer" v-html="this.question" class="survey_label"></label>
    <fieldset class="space-y-1">
      <legend class="sr-only">Answers</legend>
      <div>
        <div
          v-for="answer in prepositions"
          :key="answer"
          class="relative flex items-start"
        >
          <div class="flex items-center h-7 mb-0.5">
            <input
              :value="answer.proposition"
              :required="this.mandatory ? true : false"
              :id="answer.id"
              aria-describedby="comments-description"
              :name="name"
              :type="this.type"
              class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-blue-300 rounded"
              @change="$emit('addAnswer', $event.target.value, this.id, 'checkMultipleAnswers')"
            />
          </div>
          <div class="ml-3">
            <label :for="answer.id" class="text-gray-700">{{
              answer.proposition
            }}</label>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "CheckMultipleAnswers",
  props: ["question", "mandatory", "id", "type", "name"],

  data() {
    return {
      checked: false,
      prepositions: [],
    };
  },
  methods: {
    getPrepositions() {
      axios
        .get(`${process.env.VUE_APP_API}/v1/surveyQuestions/${this.id}`)
        .then((response) => {
          if (response) {
            this.prepositions = response.data.survey_propositions;
          } else {
            this.prepositions = [];
          }
        })
        .catch((error) => {
          this.error = error.response;
          this.errorMsg = error.response.data.response;
          console.error(error.response);
        });
    },
  },
  mounted() {
    this.getPrepositions();
  },
};
</script>

<style></style>
